export default {"src":"/_next/static/media/Pyeongchang.3f18d02a.svg","height":64,"width":64};